<template>
  <div>
    <form role="form" @submit.stop.prevent="emitForm()">
      <div class="vx-row">
        <div class="vx-col sm:w-1/1 w-full mb-2">
          <vs-select
            v-if="produtosAux.length > 0"
            v-model="form.id_produto"
            :label="`Produto`"
            class="select-large w-full"
            name="Produtos"
            v-validate="{ required: true }"
            autocomplete
            :disabled="this.dadosVeiculo.id_produto ? true : false"
            :state="validateState('Produto')"
            :danger="validateClass('Produto')"
          >
            <vs-select-item
              :key="index"
              :value="item.id"
              :text="item.label"
              v-for="(item, index) in produtosAux"
            />
          </vs-select>
          <vs-alert
            v-if="!this.dadosVeiculo.id_dependenteProduto"
            color="primary"
            title="Atenção!!"
            active="true"
            class="my-3"
            style="height: auto !important"
          >
            Somente Produtos Adicionais podem ser inseridos sem a necessidade de
            proposta
          </vs-alert>
        </div>
        <div
          class="vx-col sm:w-1/1 w-full mb-2"
          v-if="
            $can('Alterar Status Produtos', 'Veículos') &&
            this.dadosVeiculo.id_dependenteProduto
          "
        >
          <vs-select
            v-model="form.situacao"
            label="Status"
            class="select-large w-full"
            name="Status"
            v-validate="{ required: true }"
            :state="validateState('Status')"
            :danger="validateClass('Status')"
          >
            <vs-select-item
              :key="item"
              :value="item"
              :text="item"
              v-for="item in status"
            />
          </vs-select>
        </div>
        <div class="vx-col sm:w-1/1 w-full mb-2">
          <label for="" class="vs-input--label">Valor</label>
          <money
            v-if="form.valor >= 0"
            class="w-full vs-inputx vs-input--input normal"
            name="Valor"
            id="Valor"
            v-model="form.valor"
            v-validate="{ required: true }"
            :state="validateState('Valor')"
            :danger="validateClass('Valor')"
            v-bind="money"
          ></money>
          <money
            v-else
            class="w-full vs-inputx vs-input--input normal"
            name="Valor"
            id="Valor"
            v-model="form.valor"
            v-validate="{ required: true }"
            :state="validateState('Valor')"
            :danger="validateClass('Valor')"
            v-bind="money"
          ></money>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-alert
            v-if="$validator.errors.all().length > 0"
            color="danger"
            title="Atenção!!"
            active="true"
            class="my-3"
            style="height: auto !important"
          >
            <ul>
              <li
                class="mb-2"
                v-for="error in $validator.errors.all()"
                :key="error.id"
              >
                {{ error }}
              </li>
            </ul>
          </vs-alert>
        </div>
        <div class="vx-col w-full text-right">
          <BotaoSubmit
            variant="success"
            :edit="dadosVeiculo.id_dependenteProduto == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import service from './../../services';
import locale from './../../locale';
import Datepicker from 'vuejs-datepicker';
import { Money } from 'v-money';
import moment from 'moment';
import BotaoSubmit from '../../components/BotaoSubmit';
export default {
  props: ['dadosVeiculo', 'formulario', 'produtos'],
  watch: {
    dadosVeiculo(value) {
      this.preencheForm();
    },
  },
  components: { Datepicker, Money, BotaoSubmit },
  data() {
    return {
      money: {
        decimal: '.',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 2,
      },
      aguardeCadastro: false,
      status: ['ATIVO', 'INATIVO', 'PENDENTE'],
      produtosAux: [],
      form: {
        idDependenteProduto: null,
        idDependente: null,
        id_produto: null,
        valor: null,
        situacao: 'ATIVO',
      },
    };
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    preencheForm() {
      this.form.idDependente = this.dadosVeiculo.id_dependente;
      if (this.dadosVeiculo.id_dependenteProduto) {
        this.form.idDependenteProduto = this.dadosVeiculo.id_dependenteProduto;
        this.form.id_produto = this.dadosVeiculo.id_produto;
        this.form.valor = this.dadosVeiculo.valor;
        this.form.situacao = this.dadosVeiculo.situacao;
        this.form.isAdicional = this.dadosVeiculo.isAdicional;
        this.produtosAux = this.produtos;
      } else {
        this.form.idDependenteProduto = null;
        this.produtosAux = this.produtos.filter((x) => x.isAdicional == true);
        this.form.isAdicional = true;
        this.form.id_produto = null;
        this.form.descricao = null;
        this.form.valor = 0;
        this.form.situacao = 'PENDENTE';
        this.form.isAdicional = true;
      }
    },
    emitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          var newForm = {};
          Object.keys(this.form).forEach((element) => {
            if (
              typeof this.form[element] != 'object' &&
              typeof this.form[element] != 'undefined'
            ) {
              if (this.form[element] != this.dadosVeiculo[element]) {
                newForm[element] = this.form[element];
              }
            }
          });

          newForm.id_dependente = this.form.id_dependente;

          this.$emit('formAlterado', newForm);
        } else {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Existem campos não preenchidos',
            color: 'danger',
          });
        }
      });
    },
  },
  mounted() {
    this.preencheForm();
    this.$validator.localize('ptBr', locale);
  },
};
</script>
<style scoped lang="scss">
.vdp-datepicker input {
  width: 100%;
}

.vs-tabs-primary .activeChild button,
.vs-tabs-primary button:not(:disabled):hover {
  color: #fff !important;
}

.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
</style>
